import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import NormalGameManager from "../../manager/NormalGameManager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class StockEventPrefab extends cc.Component {

    @property({ type: cc.Node, displayName: "对话节点" })
    diologArray: cc.Node[] = [];
    @property({ type: cc.RichText, displayName: "文本节点" })
    textArray: cc.RichText[] = [];
    @property({ type: cc.Node, displayName: "中心节点" })
    centerNode: cc.Node = null

    textItem = 0

    richTextArray = []
    onVideoBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(() => {
            this.textItem++
            this.startText()
            this.diologArray.forEach((element, index) => {
                element.active = false
                if (index == this.textItem) {
                    element.active = true
                }
            });
        }, () => {
            O1HD.getModules().uiControlModule.showMessageBox("观看视频失败", this.node);
        }, () => {
        }, "获取股票消息");
    }

    protected start(): void {
        let stockPriceArray = NormalGameManager._instance.getGameData().stockPriceArray;
        let nameArray = [];
        nameArray.push(gameConfig.STOCK_PRICE_ADD);
        for (let index = 0; index < 2; index++) {
            let random = Math.floor(Math.random() * stockPriceArray.length);
            while (true) {
                if (nameArray.indexOf(stockPriceArray[random].name) == -1) {
                    nameArray.push(stockPriceArray[random].name);
                    break;
                } else {
                    random = Math.floor(Math.random() * stockPriceArray.length);
                }
            }
        }
        let random = Math.floor(Math.random() * 3);

        this.richTextArray.push("基金开业投资，阿里八八的老总，亲自来现场购买基金，听说码云喜欢收学生，并且手上拥有大量基金的涨跌走势，这时你准备...");
        this.richTextArray.push(`好小子，那我就把你收了！授人以鱼不如授人以渔，根据我的小道消息<color=#039FFF>【${nameArray[random % nameArray.length]}】【${nameArray[(random + 1) % nameArray.length]}】【${nameArray[(random + 2) % nameArray.length]}】</color>这几种基金中的一只肯定会大涨，你可以选择投资一下。`);
        this.richTextArray.push(`看你这么想知道，我刚刚才收到准确消息，今日必涨的那支基金就是<color=#039FFF>【${gameConfig.STOCK_PRICE_ADD}】</color>，买了必赚钱！`);
        this.startText();
    }

    startText() {
        this.textArray[this.textItem].string = this.richTextArray[this.textItem];
    }

    onCloseBtn() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if (this.textItem > 0) {
            NormalGameManager._instance.getGameData().todayDate = data_control.getCurrDateDayString();
            NormalGameManager._instance.setGameData({ todayDate: NormalGameManager._instance.getGameData().todayDate }, false);
        }
        cc.tween(this.centerNode).to(.5, { scale: 0 }, { easing: cc.easing.backIn }).call(() => {
            this.node.destroy();
        }).start();
    }
}
